module.exports = __webpack_public_path__ + "static/sinner-red-ebe2e09ab695569bdb445b7053e6b3c1.png";